import React, { useState, useEffect } from "react";
import axios from "axios";
import { Modal, Box, IconButton } from "@mui/material";
import { FaTimes } from "react-icons/fa";
import BtnLoader from "Components/Common/Loader/BtnLoader";
import { loadDecrypted } from "Common Usage/localStorageUtils"; // <-- added

const style = {
  position: "absolute",
  maxHeight: "84%",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 600,
  bgcolor: "background.paper",
  border: "none",
  borderRadius: 8,
  boxShadow: 24,
  p: 4,
  overflow: "auto",
  scrollbarWidth: "none",
};

const EditUserpopup = ({
  editUserModal,
  handleEditModalClose,
  userDetails,
  fetchUsers,
}) => {
  const [formData, setFormData] = useState({});
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (editUserModal && userDetails) {
      setFormData({
        fullName: userDetails.fullName || "",
        phone: userDetails.phone || "",
        gender: userDetails.gender || "",
        preferred_Language: userDetails.preferred_Language || "",
      });
    }
  }, [editUserModal, userDetails]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);
    setIsLoading(true);

    try {
      const config = {
        method: "put",
        url: `${process.env.REACT_APP_API_URL}/users/update/${userDetails?._id}`,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify(formData),
      };

      const response = await axios.request(config);
      setSuccess("User updated successfully!");

      // ─────────────────────────────────────────────────────────
      // Create staff activity log for user update
      // ─────────────────────────────────────────────────────────
      try {
        const staffData = loadDecrypted("HeartConnect-StaffData");
        const staffId = staffData?._id || staffData?.id || "";
        const staffName = staffData?.fullName || staffData?.name || "Unknown";

        if (staffId) {
          await axios.post(
            `${process.env.REACT_APP_API_URL}/staffs-activity-log/create-staffs-activity`,
            {
              staff: staffId,
              action: "UPDATE_USER",
              description: `Staff ${staffName} updated user ${userDetails?.fullName} (${userDetails?._id}) - New details: Name: ${formData.fullName}, Phone: ${formData.phone}, Gender: ${formData.gender}, Language: ${formData.preferred_Language}`,
            },
            { headers: { "Content-Type": "application/json" } }
          );
        }
      } catch (logErr) {
        console.error("Failed to create staff activity log:", logErr);
      }
      // ─────────────────────────────────────────────────────────

      fetchUsers(); // refresh data on parent
      handleEditModalClose(); // close modal
    } catch (err) {
      setError(
        err?.response?.data?.message || "An error occurred. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      open={editUserModal}
      onClose={handleEditModalClose}
      aria-labelledby="edit-user-modal-title"
    >
      <Box sx={style}>
        <IconButton
          aria-label="close"
          onClick={handleEditModalClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "#c51369",
          }}
        >
          <FaTimes />
        </IconButton>

        <form onSubmit={handleSubmit} className="space-y-6">
          <h2 className="mb-4 text-center text-2xl font-bold text-navy-700">
            Edit User
          </h2>

          {error && <p className="text-center text-red-500">{error}</p>}
          {success && <p className="text-center text-green-500">{success}</p>}

          <div className="space-y-4">
            <div>
              <label className="mb-2 block text-lg tracking-wide">
                Full Name
              </label>
              <input
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                className="w-full rounded-md border p-2"
                required
              />
            </div>

            <div>
              <label className="mb-2 block text-lg tracking-wide">Phone</label>
              <input
                type="text"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className="w-full rounded-md border p-2"
                required
              />
            </div>

            <div>
              <label className="mb-2 block text-lg tracking-wide">Gender</label>
              <select
                name="gender"
                value={formData.gender}
                onChange={handleChange}
                className="w-full rounded-md border p-2"
              >
                <option value="">Select</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
              </select>
            </div>

            <div>
              <label className="mb-2 block text-lg tracking-wide">
                Preferred Language
              </label>
              <select
                name="preferred_Language"
                value={formData.preferred_Language}
                onChange={handleChange}
                className="w-full rounded-md border p-2"
                required
              >
                <option value="">Select Language</option>
                <option value="English">English</option>
                <option value="Odia">Odia</option>
                <option value="Hindi">Hindi</option>
                <option value="Tamil">Tamil</option>
                <option value="Telugu">Telugu</option>
                <option value="Kannada">Kannada</option>
                <option value="Bengali">Bengali</option>
                <option value="Marathi">Marathi</option>
                <option value="Gujarati">Gujarati</option>
              </select>
            </div>

            <div className="mt-6">
              <button
                type="submit"
                className="flex w-full items-center justify-center rounded-md bg-[#c51369] p-3 font-medium text-white transition hover:bg-[#a10f5b]"
                disabled={isLoading}
              >
                {isLoading ? <BtnLoader /> : "Save Changes"}
              </button>
            </div>
          </div>
        </form>
      </Box>
    </Modal>
  );
};

export default EditUserpopup;







// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { Modal, Box, IconButton } from "@mui/material";
// import { FaTimes } from "react-icons/fa";
// import BtnLoader from "Components/Common/Loader/BtnLoader";

// const style = {
//   position: "absolute",
//   maxHeight: "84%",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: "90%",
//   maxWidth: 600,
//   bgcolor: "background.paper",
//   border: "none",
//   borderRadius: 8,
//   boxShadow: 24,
//   p: 4,
//   overflow: "auto",
//   scrollbarWidth: "none",
// };

// const EditUserpopup = ({
//   editUserModal,
//   handleEditModalClose,
//   userDetails,
//   fetchUsers,
// }) => {
//   const [formData, setFormData] = useState({});
//   const [error, setError] = useState(null);
//   const [success, setSuccess] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);

//   useEffect(() => {
//     if (editUserModal && userDetails) {
//       setFormData({
//         fullName: userDetails.fullName || "",
//         phone: userDetails.phone || "",
//         gender: userDetails.gender || "",
//         preferred_Language: userDetails.preferred_Language || "",
//       });
//     }
//   }, [editUserModal, userDetails]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError(null);
//     setSuccess(null);
//     setIsLoading(true);

//     try {
//       const config = {
//         method: "put",
//         url: `${process.env.REACT_APP_API_URL}/users/update/${userDetails?._id}`,
//         headers: {
//           "Content-Type": "application/json",
//         },
//         data: JSON.stringify(formData),
//       };

//       const response = await axios.request(config);
//       setSuccess("User updated successfully!");
//       fetchUsers(); // refresh data on parent
//       handleEditModalClose(); // close modal
//     } catch (err) {
//       setError(
//         err?.response?.data?.message || "An error occurred. Please try again."
//       );
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <Modal
//       open={editUserModal}
//       onClose={handleEditModalClose}
//       aria-labelledby="edit-user-modal-title"
//     >
//       <Box sx={style}>
//         <IconButton
//           aria-label="close"
//           onClick={handleEditModalClose}
//           sx={{
//             position: "absolute",
//             right: 8,
//             top: 8,
//             color: "#c51369",
//           }}
//         >
//           <FaTimes />
//         </IconButton>

//         <form onSubmit={handleSubmit} className="space-y-6">
//           <h2 className="mb-4 text-center text-2xl font-bold text-navy-700">
//             Edit User
//           </h2>

//           {error && <p className="text-center text-red-500">{error}</p>}
//           {success && <p className="text-center text-green-500">{success}</p>}

//           <div className="space-y-4">
//             <div>
//               <label className="mb-2 block text-lg tracking-wide">
//                 Full Name
//               </label>
//               <input
//                 type="text"
//                 name="fullName"
//                 value={formData.fullName}
//                 onChange={handleChange}
//                 className="w-full rounded-md border p-2"
//                 required
//               />
//             </div>

//             <div>
//               <label className="mb-2 block text-lg tracking-wide">Phone</label>
//               <input
//                 type="text"
//                 name="phone"
//                 value={formData.phone}
//                 onChange={handleChange}
//                 className="w-full rounded-md border p-2"
//                 required
//               />
//             </div>

//             <div>
//               <label className="mb-2 block text-lg tracking-wide">Gender</label>
//               <select
//                 name="gender"
//                 value={formData.gender}
//                 onChange={handleChange}
//                 className="w-full rounded-md border p-2"
//               >
//                 <option value="">Select</option>
//                 <option value="male">Male</option>
//                 <option value="female">Female</option>
//                 <option value="other">Other</option>
//               </select>
//             </div>

//             <div>
//               <label className="mb-2 block text-lg tracking-wide">
//                 Preferred Language
//               </label>
//               <select
//                 name="preferred_Language"
//                 value={formData.preferred_Language}
//                 onChange={handleChange}
//                 className="w-full rounded-md border p-2"
//                 required
//               >
//                 <option value="">Select Language</option>
//                 <option value="English">English</option>
//                 <option value="Odia">Odia</option>
//                 <option value="Hindi">Hindi</option>
//                 <option value="Tamil">Tamil</option>
//                 <option value="Telugu">Telugu</option>
//                 <option value="Kannada">Kannada</option>
//                 <option value="Bengali">Bengali</option>
//                 <option value="Marathi">Marathi</option>
//                 <option value="Gujarati">Gujarati</option>
//               </select>
//             </div>

//             <div className="mt-6">
//               <button
//                 type="submit"
//                 className="flex w-full items-center justify-center rounded-md bg-[#c51369] p-3 font-medium text-white transition hover:bg-[#a10f5b]"
//                 disabled={isLoading}
//               >
//                 {isLoading ? <BtnLoader /> : "Save Changes"}
//               </button>
//             </div>
//           </div>
//         </form>
//       </Box>
//     </Modal>
//   );
// };

// export default EditUserpopup;
